(function () {
  'use strict';

  angular.module('unit.cancel.deal', []);
})();
